<template>
  <li
    :id="tabKey + '_link'"
    role="tab"
    :aria-label="tabName"
    :aria-selected="isSelected"
    :aria-controls="tabKey + '_tab'"
  >
    <h3
      ref="tab"
      :class="{
        'o-human-made-object-tabs__tab--inactive': !isSelected,
        'o-human-made-object-tabs__tab': true
      }"
      :aria-controls="tabKey + '_tab'"
      tabindex="0"
      @click="changeTab"
      @keydown.enter="changeTab"
      @keydown.space.stop.prevent="changeTab"
    >
      {{ tabName }}
    </h3>
    <Credits :credits-active="creditsActive" @click="handleClick">
      <RichText :content="translatePart(`tab.${tabKey}.tooltip`)" />
    </Credits>
  </li>
</template>
<script>
import { Credits, RichText, useLocalization } from "@thegetty-private/getty-ui";

export default {
  name: "HumanMadeObjectTab",
  components: { Credits, RichText },
  props: {
    baseLocaleKey: {
      type: String,
      default: "human_made_object_tabs"
    },
    /**
     * Whether the tab is currently selected
     */
    isSelected: {
      type: Boolean,
      default: false
    },
    /**
     * The key for the tab
     */
    tabKey: {
      type: String,
      required: true
    },
    /**
     * The display name for the tab
     */
    tabName: {
      type: String,
      required: true
    },
    creditsActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ["changeTab", "creditsActive"],
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  methods: {
    /**
     * Fires an event when the tab is changed (unless the tab is already selected)
     *
     * @emits {changeTab}
     */
    changeTab() {
      if (this.isSelected) {
        return;
      }
      this.$emit("changeTab", this.tabKey);
    },
    /**
     * Fires an event when credits component (tab tooltip) is active
     * @emits {creditsActive}
     */
    handleClick() {
      this.$emit("creditsActive", this.tabKey);
    }
  }
};
</script>
